import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { Select } from 'src/domains/layouts/shared/formComponents/Select/components/Select';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { HeadlineCarouselState } from '../HeadlineCarousel.state';
import { ErrorMessageBar } from 'src/domains/layouts/shared/formComponents/FormComponents.style';

interface PropsTypes {
    headlineCarouselState: HeadlineCarouselState,
}
export enum RedirectTypeEnum {
    REDIRECT_NONE = 'NONE',
    REDIRECT_URL = 'REDIRECT_URL',
    REDIRECT_GAME = 'REDIRECT_GAME',
    REDIRECT_CATEGORY_CASINO = 'REDIRECT_CATEGORY_CASINO',
    REDIRECT_CATEGORY_LIVE_CASINO = 'REDIRECT_CATEGORY_LIVE_CASINO',
  }

export const RedirectOptions = observer(({ headlineCarouselState }: PropsTypes): React.ReactElement | null => {
    const { appCasinoState } = useAppStateContext();
    const { gamesOptionsForPromos } = appCasinoState.gameStore;
    const {
        redirectUrl,
        redirectGame,
        redirectCategory,
        redirectType,
        redirectionError,
    } = headlineCarouselState.headlineBannersData;

    const { liveCasinoCategories, casinoCategories } = headlineCarouselState;
 
    return (
        <>
            {redirectType.value === RedirectTypeEnum.REDIRECT_URL && (
                <Input
                    inputType='url'
                    label='Direct link *'
                    formInputState={redirectUrl}
                />
            )}
            {redirectType.value === RedirectTypeEnum.REDIRECT_NONE && (
                null
            )}
            {redirectType.value === RedirectTypeEnum.REDIRECT_GAME && (
                <Select defaultText='Select game *' selectOptions={gamesOptionsForPromos} stateValue={redirectGame} />
            )}
            {redirectType.value === RedirectTypeEnum.REDIRECT_CATEGORY_CASINO && (
                <Select defaultText='Select category - Casino *' selectOptions={casinoCategories} stateValue={redirectCategory} />
            )}
            {redirectType.value === RedirectTypeEnum.REDIRECT_CATEGORY_LIVE_CASINO && (
                <Select defaultText='Select category - Live Casino *' selectOptions={liveCasinoCategories} stateValue={redirectCategory} />

            )}
            {redirectionError !== null && (
                <ErrorMessageBar>{redirectionError}</ErrorMessageBar>
            )}
        </>
    );
});
